import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

@Injectable()
export class MfaService {

  constructor(private apiService: ApiService) {}

  /**
   * Send mfa code to destination
   */
  sendCode(destination: string, action: string): Observable<any> {
    return this.apiService.post<any>('send/mfa/code', { destination, action });
  }

  /**
   * Check mfa code
   */
  checkCode(destination: string, action: string, code: string): Observable<any> {
    return this.apiService.post<any>('check/mfa/code', { destination, action, code });
  }

  /**
   * Check login mfa code
   */
  checkLoginCode(destination: string, action: string, code: string, customerId: string): Observable<any> {
    return this.apiService.post<any>('vitrine/check/login/mfa/code', { destination, action, code, customerId });
  }
}
